import { useEffect } from 'react'
import {} from 'react-router-dom'
import { RoutesPath } from '../../configs/routes-path'
import { useNavigateRoute } from '../hooks/navigation'

export const Example = () => {
  // const [, setSearchParams] = useSearchParams()
  const { navigateTo } = useNavigateRoute()

  useEffect(() => {
    navigateTo(RoutesPath.login)
    /*  setSearchParams({
      exampleParam: 'value-example'
    }) */
  }, [])

  return <div className="bg-red"></div>
}
